import { useParams } from 'react-router-dom'

import { useLocationContext } from '@providers/location'
import { isoTomorrowTZ } from 'components-ui/src/shared/dates'
import { useClientReports } from 'service-api/src/hooks/use_client_reports'

const WALLET_BALANCE_REPORT = 'wallet-credit-balance-by-date'

export const useWalletBalance = (lupId: string, props: { cacheEnabled?: boolean }) => {
  const { accountName: locationName = '' } = useParams()
  const { cacheEnabled = false } = props || {}
  const location = useLocationContext()

  const { data: walletBalance, isFetching } = useClientReports(
    locationName,
    lupId,
    WALLET_BALANCE_REPORT,
    { filter: { date: isoTomorrowTZ(location.location?.timezone ?? undefined) } },
    { cacheEnabled, enabled: !!lupId }
  )

  return {
    walletBalance: walletBalance?.total || 0,
    isFetching,
  }
}
